/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAttachCaseTransactionsRequest,
    InternalApiAttachCaseTransactionsRequestFromJSON,
    InternalApiAttachCaseTransactionsRequestToJSON,
    InternalApiCaseTransactionPage,
    InternalApiCaseTransactionPageFromJSON,
    InternalApiCaseTransactionPageToJSON,
    InternalApiDetachCaseTransactionsRequest,
    InternalApiDetachCaseTransactionsRequestFromJSON,
    InternalApiDetachCaseTransactionsRequestToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface AttachCaseTransactionsRequest {
    handle: string;
    internalApiAttachCaseTransactionsRequest: InternalApiAttachCaseTransactionsRequest;
}

export interface DetachCaseTransactionsRequest {
    handle: string;
    internalApiDetachCaseTransactionsRequest: InternalApiDetachCaseTransactionsRequest;
}

export interface FindCaseTransactionsPageRequest {
    handle: string;
    size: number;
    page: number;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

/**
 * 
 */
export class CaseTransactionInternalApi extends runtime.BaseAPI {

    /**
     * Attaches transactions to a case
     */
    async attachCaseTransactionsRaw(requestParameters: AttachCaseTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling attachCaseTransactions.');
        }

        if (requestParameters.internalApiAttachCaseTransactionsRequest === null || requestParameters.internalApiAttachCaseTransactionsRequest === undefined) {
            throw new runtime.RequiredError('internalApiAttachCaseTransactionsRequest','Required parameter requestParameters.internalApiAttachCaseTransactionsRequest was null or undefined when calling attachCaseTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/transactions`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAttachCaseTransactionsRequestToJSON(requestParameters.internalApiAttachCaseTransactionsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Attaches transactions to a case
     */
    async attachCaseTransactions(requestParameters: AttachCaseTransactionsRequest, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.attachCaseTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Detaches transactions from a case
     */
    async detachCaseTransactionsRaw(requestParameters: DetachCaseTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling detachCaseTransactions.');
        }

        if (requestParameters.internalApiDetachCaseTransactionsRequest === null || requestParameters.internalApiDetachCaseTransactionsRequest === undefined) {
            throw new runtime.RequiredError('internalApiDetachCaseTransactionsRequest','Required parameter requestParameters.internalApiDetachCaseTransactionsRequest was null or undefined when calling detachCaseTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/transactions`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiDetachCaseTransactionsRequestToJSON(requestParameters.internalApiDetachCaseTransactionsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Detaches transactions from a case
     */
    async detachCaseTransactions(requestParameters: DetachCaseTransactionsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.detachCaseTransactionsRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches paginated transactions associated with a case
     */
    async findCaseTransactionsPageRaw(requestParameters: FindCaseTransactionsPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCaseTransactionPage>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseTransactionsPage.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findCaseTransactionsPage.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findCaseTransactionsPage.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/transactions`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseTransactionPageFromJSON(jsonValue));
    }

    /**
     * Fetches paginated transactions associated with a case
     */
    async findCaseTransactionsPage(requestParameters: FindCaseTransactionsPageRequest, initOverrides?: RequestInit): Promise<InternalApiCaseTransactionPage> {
        const response = await this.findCaseTransactionsPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
